import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown, HelpCircle } from "lucide-react";

// FAQ Data - 25 questions for SEO
const faqData = [
  {
    category: "Pre nerozhodných",
    questions: [
      {
        q: "Ako viem, že mi cena počas stavby nenarastie?",
        a: "V zmluve máte pevne zapísanú cenu, ktorá sa nemení. Akékoľvek dodatočné práce (napr. zmena obkladu, zásuvka navyše) realizujeme až po vašom písomnom odsúhlasení konkrétnej ceny. Nikdy sa nestane, že by ste dostali faktúru s prekvapením — každý eur je odsúhlasený vopred. Vzor našej zmluvy vám radi pošleme ešte pred obhliadkou."
      },
      {
        q: "Čo ak si to po podpise zmluvy rozmyslím?",
        a: "Máte 7-dňovú skúšobnú lehotu po podpise zmluvy. V tomto období môžete od zmluvy odstúpiť bez sankcie a vrátime vám celú zálohu. Pozri sekciu Naše záruky. Táto klauzula je priamo v zmluve, nie je to len ústny sľub."
      },
      {
        q: "Ako si vás mám overiť? Nechcem naletieť.",
        a: "Sme RESTOB s.r.o., IČO 50 538 381, zapísaná v Obchodnom registri SR od roku 2009. Nájdete nás na finstat.sk, orsr.sk, aj v registri partnerov verejného sektora. Máme 4.9★ na Google, viac ako 40 verifikovaných recenzií. Na požiadanie vám dáme 3 osobné referencie z posledných 12 mesiacov — klienti, ktorých môžete zavolať alebo osobne navštíviť."
      },
      {
        q: "Kedy môžete začať s mojou stavbou?",
        a: "Pri rekonštrukciách zvyčajne do 3–4 týždňov od podpisu zmluvy. Pri novostavbách (holodom, dom na kľúč) závisí od projektu a stavebného povolenia — obvykle 2–3 mesiace. Presný termín začatia máte v zmluve a garantujeme ho penále za omeškanie."
      },
      {
        q: "Aký je rozdiel medzi vami a lacnejšou konkurenciou?",
        a: "Máme vlastný tím (nie poddodávateľov), fixnú cenu v zmluve, denné foto-reporty, 3-ročnú záruku a poistenie zodpovednosti do 100 000 €. Lacnejšie firmy typicky pracujú so subdodávateľmi (žiadna kontrola kvality), majú orientačnú cenu (v realite +15–30 %) a záruku len ústne. Ak vidíte cenu o 20 % lacnejšiu, opýtajte sa: aká je pokuta za omeškanie, kto konkrétne bude stavať, čo pokrýva záruka."
      },
      {
        q: "Môžem si k vám prísť na obhliadku vášho tímu / rozostavanej stavby?",
        a: "Určite. Kedykoľvek vás vieme zobrať priamo na aktívnu stavbu (po dohode s klientom, u ktorého staviame), aby ste videli náš tím pri práci, kvalitu remesla aj to, ako sa správame k stavenisku. Toto je najlepší spôsob, ako si nás overiť."
      },
      {
        q: "Čo ak sa mi počas stavby prestane niečo páčiť alebo sa nedohodneme?",
        a: "V zmluve máte definovaný postup riešenia sporov: 1) písomná pripomienka do 3 dní, 2) spoločná obhliadka do 7 dní, 3) písomný záver + termín nápravy. Pri závažných chybách máte právo pozastaviť ďalšie platby, kým sa problém nevyrieši. Ak nevieme nájsť dohodu, spor rieši Rozhodcovský súd SR (rýchlejšie a lacnejšie ako všeobecný súd)."
      },
      {
        q: "Prečo mi vlastne mám dôverovať práve vám?",
        a: "Krátka odpoveď: pretože všetko, čo hovoríme, si viete overiť. Recenzie máte na Google, financie na finstat.sk, referencie osobne pozviete na kávu, cenu podpisujeme, denne posielame fotky, penále platíme ak meškáme. Ak sa niečo nedá overiť, opýtajte sa nás na to — radi vám ukážeme dôkaz. Dôvera sa nedá kúpiť. Dá sa iba postupne budovať dôkazmi."
      }
    ]
  },
  {
    category: "Ceny a platby",
    questions: [
      {
        q: "Koľko stojí stavba rodinného domu na kľúč v Bratislave?",
        a: "Cena stavby rodinného domu na kľúč v Bratislave závisí od veľkosti a štandardu. Holodom (hrubá stavba) stojí od 960€/m², kompletná stavba na kľúč od 1400-2000€/m². Pre 150m² dom to znamená približne 144 000€ za holodom alebo 210 000-300 000€ na kľúč. Kontaktujte nás pre presnú kalkuláciu."
      },
      {
        q: "Aká je cena zateplenia fasády rodinného domu?",
        a: "Zateplenie fasády ponúkame od 48€/m² vrátane materiálu (polystyrén 10cm), práce, lešenia a omietky. Pre priemerný rodinný dom s fasádou 200m² je to približne 9 600€. Cena môže byť vyššia pri použití minerálnej vaty alebo hrubšej izolácie."
      },
      {
        q: "Koľko stojí zámková dlažba s montážou?",
        a: "Pokládka zámkovej dlažby vrátane materiálu a podkladu stojí od 70€/m². Cena zahŕňa prípravu podkladu, štrk, piesok, dlažbu a obrubníky. Pre príjazdovú cestu 50m² počítajte s investíciou približne 3 500€."
      },
      {
        q: "Aké sú platobné podmienky?",
        a: "Štandardne požadujeme zálohu 30% pri podpise zmluvy, 40% v priebehu realizácie a 30% po dokončení a odovzdaní diela. Pri väčších projektoch je možné dohodnúť individuálny splátkový kalendár."
      },
      {
        q: "Poskytujete cenové ponuky zadarmo?",
        a: "Áno, cenová ponuka a konzultácia sú úplne zadarmo a nezáväzné. Obhliadku realizujeme do 48 hodín od vášho kontaktovania. Stačí zavolať na 0907 64 99 64 alebo vyplniť kontaktný formulár."
      }
    ]
  },
  {
    category: "Termíny a realizácia",
    questions: [
      {
        q: "Ako dlho trvá stavba rodinného domu?",
        a: "Hrubá stavba (holodom) trvá 3-5 mesiacov v závislosti od veľkosti a počasia. Kompletná stavba na kľúč vrátane interiéru trvá 8-14 mesiacov. Termíny sú vždy uvedené v zmluve a dodržiavame ich."
      },
      {
        q: "Kedy je najlepšie začať so stavbou?",
        a: "Ideálne je začať na jar (marec-apríl), kedy je počasie priaznivé pre zemné práce a betónovanie. Projekty plánujeme aj na jeseň. V zime realizujeme interiérové práce, rekonštrukcie a dokončovacie práce."
      },
      {
        q: "Ako dlho trvá zateplenie fasády?",
        a: "Zateplenie fasády rodinného domu trvá zvyčajne 2-4 týždne v závislosti od veľkosti a zložitosti. Počas prác nie je potrebné sa vysťahovať, pracujeme z vonkajšej strany."
      },
      {
        q: "Môžete pracovať aj cez víkendy?",
        a: "Štandardne pracujeme pondelok až piatok od 7:00 do 17:00. Pri urgentných projektoch alebo na požiadanie zákazníka môžeme pracovať aj v sobotu. Nedeľa je deň odpočinku."
      }
    ]
  },
  {
    category: "Kvalita a záruka",
    questions: [
      {
        q: "Akú záruku poskytujete na stavebné práce?",
        a: "Na všetky naše práce poskytujeme 3-ročnú (36-mesačnú) záruku. Na strechy a hydroizolácie až 10 rokov. Reklamácie vybavujeme do 48 hodín. Používame len certifikované materiály od overených dodávateľov."
      },
      {
        q: "Aké materiály používate?",
        a: "Používame prémiové materiály od značiek Porotherm, Ytong, Baumit, Weber, Bramac, Velux, Rehau, Knauf a ďalších. Všetky materiály majú certifikáty kvality a sú vhodné pre slovenské klimatické podmienky."
      },
      {
        q: "Máte poistenie zodpovednosti za škody?",
        a: "Áno, máme uzatvorené poistenie zodpovednosti za škodu spôsobenú pri výkone povolania do výšky 500 000€. Klient je plne chránený počas celej realizácie projektu."
      },
      {
        q: "Ako kontrolujete kvalitu práce?",
        a: "Každý projekt má priradeného stavbyvedúceho, ktorý denne kontroluje kvalitu. Pred odovzdaním robíme kompletnú kontrolu podľa checklistu. Zákazník dostáva pravidelné fotoreporty z priebehu stavby."
      }
    ]
  },
  {
    category: "Služby a rozsah",
    questions: [
      {
        q: "V akých mestách poskytujete služby?",
        a: "Pôsobíme v Bratislave a celom západnom Slovensku - okresy Senec, Pezinok, Malacky, Trnava, Dunajská Streda, Galanta, Komárno, Nové Zámky, Levice, Nitra a ďalšie. Celkovo pokrývame viac ako 500 miest a obcí."
      },
      {
        q: "Robíte aj menšie rekonštrukcie bytov?",
        a: "Áno, realizujeme kompletné aj čiastočné rekonštrukcie bytov - kúpeľne, kuchyne, podlahy, elektroinštalácie, maľovanie. Minimálna zákazka je od 2 000€. Pre menšie opravy odporúčame lokálnych remeselníkov."
      },
      {
        q: "Vybavíte aj stavebné povolenie?",
        a: "Áno, ponúkame komplexný servis vrátane projektu, vybavenia stavebného povolenia a kolaudácie. Spolupracujeme s overenými architektmi a projektantmi. Celý proces zabezpečíme za vás."
      },
      {
        q: "Staviate aj pasívne domy?",
        a: "Áno, máme skúsenosti so stavbou nízkoenergetických a pasívnych domov v energetickej triede A0 a A1. Používame systémy Porotherm, rekuperáciu a tepelné čerpadlá pre maximálnu energetickú úsporu."
      },
      {
        q: "Robíte aj bazény a záhradné úpravy?",
        a: "Áno, staviam bazény na kľúč (betónové aj fóliové), terasy, pergoly, altánky, zámkovú dlažbu, ploty a kompletné záhradné úpravy. Dokážeme zrealizovať celý exteriér vášho domu."
      }
    ]
  },
  {
    category: "Komunikácia a proces",
    questions: [
      {
        q: "Ako prebieha spolupráca od začiatku?",
        a: "1) Bezplatná konzultácia a obhliadka, 2) Cenová ponuka do 3 dní, 3) Podpis zmluvy a záloha, 4) Realizácia s pravidelnými reportmi, 5) Kontrola a odovzdanie, 6) Fakturácia a záručný servis."
      },
      {
        q: "Ako vás môžem kontaktovať počas stavby?",
        a: "Každý zákazník dostane priamy kontakt na stavbyvedúceho. Komunikujeme cez WhatsApp skupinu, kde zdieľame denné fotky z postupu prác. Sme dostupní na telefóne 0907 64 99 64 od 7:00 do 19:00."
      },
      {
        q: "Upratujete po sebe?",
        a: "Áno, po dokončení prác vždy upratujeme a odvážame stavebný odpad. Odovzdávame čistú a pripravenú stavbu. Odvoz sutiny je zahrnutý v cene alebo účtovaný zvlášť podľa dohody."
      },
      {
        q: "Čo ak počas stavby vzniknú dodatočné práce?",
        a: "Akékoľvek dodatočné práce realizujeme len po písomnom odsúhlasení zákazníkom s uvedením ceny. Nikdy neúčtujeme práce, ktoré neboli vopred dohodnuté. Transparentnosť je náš základ."
      }
    ]
  },
  {
    category: "Špeciálne otázky",
    questions: [
      {
        q: "Môžem si kúpiť materiál sám?",
        a: "Áno, je to možné. V takom prípade poskytujeme len prácu bez materiálu. Upozorňujeme však, že v tomto prípade záruka na materiál nie je z našej strany. Odporúčame využiť naše výhodné ceny od dodávateľov."
      },
      {
        q: "Robíte stavby aj pre firmy a developerov?",
        a: "Áno, spolupracujeme s developermi, firmami a investormi. Máme skúsenosti s bytovými domami, administratívnymi budovami a priemyselnými halami. Pre B2B projekty ponúkame individuálne podmienky."
      },
      {
        q: "Ako dlho pôsobíte na trhu?",
        a: "Firma RESTOB s.r.o. pôsobí na trhu od roku 2009, teda viac ako 15 rokov. Za túto dobu sme zrealizovali viac ako 500 projektov a získali si dôveru stoviek spokojných zákazníkov v celom regióne."
      }
    ]
  }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [activeCategory, setActiveCategory] = useState("all");

  const allQuestions = activeCategory === "all" 
    ? faqData.flatMap(cat => cat.questions.map(q => ({ ...q, category: cat.category })))
    : faqData.find(cat => cat.category === activeCategory)?.questions.map(q => ({ ...q, category: activeCategory })) || [];

  return (
    <section className="py-24 lg:py-32 section-dark tech-grid" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <div className="inline-flex items-center gap-2 bg-[#00E5FF]/10 text-[#00E5FF] px-4 py-2 rounded-full text-sm mb-4">
            <HelpCircle size={16} />
            <span className="mono uppercase tracking-wider text-xs">Často kladené otázky</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-black tracking-tight">
            Máte <span className="text-[#FF5E00]">otázky?</span>
          </h2>
          <p className="text-zinc-500 mt-4 max-w-xl mx-auto">
            Nájdite odpovede na najčastejšie otázky o našich stavebných službách, cenách a procese spolupráce.
          </p>
        </motion.div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-2 mb-8">
          <button
            onClick={() => setActiveCategory("all")}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
              activeCategory === "all"
                ? "bg-[#00E5FF] text-black"
                : "bg-white/5 text-zinc-400 hover:bg-white/10"
            }`}
          >
            Všetky ({faqData.reduce((acc, cat) => acc + cat.questions.length, 0)})
          </button>
          {faqData.map((cat, i) => (
            <button
              key={i}
              onClick={() => setActiveCategory(cat.category)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                activeCategory === cat.category
                  ? "bg-[#00E5FF] text-black"
                  : "bg-white/5 text-zinc-400 hover:bg-white/10"
              }`}
            >
              {cat.category} ({cat.questions.length})
            </button>
          ))}
        </div>

        {/* Questions */}
        <div className="space-y-3">
          {allQuestions.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
              className="glass-card overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 text-left group"
                data-testid={`faq-question-${index}`}
              >
                <span className="font-medium text-white group-hover:text-[#00E5FF] transition-colors pr-4">
                  {item.q}
                </span>
                <ChevronDown 
                  size={20} 
                  className={`text-[#00E5FF] flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                />
              </button>
              
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <div className="px-5 pb-5 text-zinc-400 leading-relaxed border-t border-white/5 pt-4">
                      {item.a}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <p className="text-zinc-500 mb-4">Nenašli ste odpoveď na svoju otázku?</p>
          <a
            href="#kontakt"
            className="inline-flex items-center gap-2 btn-primary"
            data-testid="faq-contact-cta"
          >
            Napíšte nám
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;
